import { Component } from '@angular/core';

@Component({
    selector: 'app-side-paragraph',
    templateUrl: './side-paragraph.component.html',
    styleUrls: ['./side-paragraph.component.scss'],
})
export class SideParagraphComponent {
    constructor() {}
}
